import { html, css } from 'lit-element';
import './soccer-season-auth-detail.js';
import { SPLeagueDetail } from './sp-league-detail.js';

class CricketLeagueDetail extends SPLeagueDetail {
    constructor() {
        super();
    }

    static get styles() {
        return [super.styles, css``];
    }

    static get properties() {
        return {};
    }
}

window.customElements.define('cricket-league-detail', CricketLeagueDetail);
